import { userBudget } from './api';

const fetchUserBudget = (context) => {
	return new Promise((resolve, reject) => {
    	userBudget()
	    	.then((response) => {
		  		context.commit('USER_BUDGET', response.data.data);
		  		resolve(response.data.data);
			})
			.catch((error) => {
		  		console.error(error);
		  		reject(error);
			});
    });
};

export default {
  fetchUserBudget,
};